import React, { useEffect, useRef, useState } from "react";
import { X, Phone } from "lucide-react";
import "./PosterPopup.css";
import Whatsappicon from "../../assets/logo/whatsapp.png";
import Gmail from "../../assets/logo/gmail.png";
import { posterData } from "./popupPosterdata";

const AUTO_CLOSE_TIME = 20000; // 20 sec
const ROTATE_TIME = 240000;    // 4 min

export default function PosterPopup() {
  const [visible, setVisible] = useState(false);
  const [adIndex, setAdIndex] = useState(0);

  const autoCloseTimer = useRef(null);
  const rotateTimer = useRef(null);
  const firstTimer = useRef(null);

  useEffect(() => {
    const showRandomPoster = () => {
      const randomIndex = Math.floor(Math.random() * posterData.length);
      setAdIndex(randomIndex);
      setVisible(true);

      clearTimeout(autoCloseTimer.current);
      autoCloseTimer.current = setTimeout(() => {
        setVisible(false);
      }, AUTO_CLOSE_TIME);
    };

    // ⏳ First popup AFTER 4 minutes
    firstTimer.current = setTimeout(() => {
      showRandomPoster();

      // 🔁 Every 4 minutes after
      rotateTimer.current = setInterval(() => {
        showRandomPoster();
      }, ROTATE_TIME);
    }, ROTATE_TIME);

    return () => {
      clearTimeout(firstTimer.current);
      clearInterval(rotateTimer.current);
      clearTimeout(autoCloseTimer.current);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="poster-overlay">
      <div className="poster-box">
        <button className="poster-close" onClick={() => setVisible(false)}>
          <X size={20} />
        </button>

        <a
          href={
            posterData[adIndex].website.startsWith("http")
              ? posterData[adIndex].website
              : `https://${posterData[adIndex].website}`
          }
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={posterData[adIndex].image}
            alt="Promotional Poster"
            className="poster-img"
          />
        </a>

        <div className="poster-connect">
          <a
            href={`https://wa.me/${posterData[adIndex].whatsapp}`}
            target="_blank"
            rel="noreferrer"
          >
            <img src={Whatsappicon} alt="WhatsApp" />
          </a>

          <a href={`tel:+${posterData[adIndex].phone}`}>
            <Phone size={28} />
          </a>

          <a href={`mailto:${posterData[adIndex].email}`}>
            <img src={Gmail} alt="Mail" />
          </a>
        </div>
      </div>
    </div>
  );
}